import { OptionType } from "elements/DropdownList/DropdownList";
import { useRef } from "react";
import { useSitesAndRoomsQuery } from "generated/graphql";
import { VOID_TID } from "Constants";
import { useTenantId } from "polyrouter/SelectedTenantProvider";

const sortOptions = (a: OptionType, b: OptionType) => {
  return a.text.localeCompare(b.text, undefined, { sensitivity: "base" });
};

const useSitesAndRooms = () => {
  const tenantId = useTenantId();
  let sites: Array<OptionType> = [];
  let sitesWithNames: Array<OptionType> = [];
  let roomsRef = useRef([] as Array<OptionType>);
  const { data: siteMeta } = useSitesAndRoomsQuery({
    variables: {
      tenantId: tenantId !== VOID_TID ? tenantId : undefined
    }
  });

  if (siteMeta && siteMeta.sites) {
    sites = siteMeta.sites
      .map(site => ({
        text: site.name,
        value: site.id
      }))
      .sort(sortOptions);

    sitesWithNames = siteMeta.sites
      .map(site => ({
        text: site.name,
        value: site.name
      }))
      .sort(sortOptions);

    let roomSet = new Set();
    siteMeta.sites.forEach(site => {
      site.rooms.forEach(room => {
        roomSet.add(room.name);
      });
    });

    roomsRef.current = Array.from(roomSet)
      .map(roomName => {
        return {
          text: roomName,
          value: roomName
        } as OptionType;
      })
      .sort(sortOptions);
  }

  return { sites, roomsRef, siteMeta, sitesWithNames };
};

export default useSitesAndRooms;
